import { gqlRequestType } from '@minecraft.graphql-types';
import { useTranslation } from '@blocs.i18n';
import { SelectOption } from '../types';

export const useRequestTypeOptions = (): Array<SelectOption> => {
  const { t } = useTranslation();

  return [
    { value: gqlRequestType.AUDITION, label: t('common:role.audition') },
    { value: gqlRequestType.CALLBACK, label: t('common:role.callback') },
    { value: gqlRequestType.ASK_QUESTION, label: t('common:requestType.question') },
    { value: gqlRequestType.MEDIA, label: t('common:mediaType.media') },
  ];
};
